import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaBullhorn, FaRobot, FaChartBar, FaLightbulb } from 'react-icons/fa';
import Section from '../common/Section';
import ServiceCard from '../common/ServiceCard';

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.space.xl};
  margin-top: ${({ theme }) => theme.space.xl};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

const SectionTitle = styled(motion.h2)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

const SectionSubtitle = styled(motion.p)`
  text-align: center;
  max-width: 600px;
  margin: 0 auto ${({ theme }) => theme.space.xl};
  color: ${({ theme }) => theme.colors.grey[700]};
  font-size: ${({ theme }) => theme.fontSizes.lg};
`;

const services = [
  {
    icon: <FaBullhorn />,
    title: 'Digital Marketing',
    description: 'Strategic campaigns across Google, Facebook, WhatsApp, and Email platforms to maximize your brand reach and conversion rates.',
    linkTo: '/services/digital-marketing',
  },
  {
    icon: <FaRobot />,
    title: 'AI-Powered Analytics',
    description: 'Leverage machine learning algorithms for precise customer segmentation, behavior prediction, and data-driven forecasting.',
    linkTo: '/services/ai-analytics',
  },
  {
    icon: <FaChartBar />,
    title: 'Business Intelligence',
    description: 'Real-time data visualization through custom PowerBI and Tableau dashboards for informed business decisions.',
    linkTo: '/services/business-intelligence',
  },
  {
    icon: <FaLightbulb />,
    title: 'Strategic Consulting',
    description: 'Comprehensive market analysis and bespoke strategies to optimize customer journeys and marketing funnels.',
    linkTo: '/services/strategic-consulting',
  },
];

const ServicesSection: React.FC = () => {
  return (
    <Section id="services" backgroundColor="#f8f9fa">
      <SectionTitle
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.5 }}
      >
        Our Services
      </SectionTitle>
      
      <SectionSubtitle
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        We provide comprehensive data-driven solutions to help your business grow
      </SectionSubtitle>
      
      <ServicesGrid>
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            icon={service.icon}
            title={service.title}
            description={service.description}
            linkTo={service.linkTo}
            delay={0.2 * (index + 1)}
          />
        ))}
      </ServicesGrid>
    </Section>
  );
};

export default ServicesSection;
